import { Tree } from "fluid-framework";
import { useEffect, useState } from "react";

import { useAuth } from "../auth/use-auth.js";
import {
  getTableIdFromUser,
  isUserInAreaWithoutVoiceCall,
} from "../fluid/fluid.service.js";
import { useFluid } from "../fluid/hooks/use-fluid.js";

export const useCurrentUserTablePresence = () => {
  const { user } = useAuth();
  const { sharedTree } = useFluid();
  const [currentTableId, setCurrentTableId] = useState<string | null>(null);

  useEffect(() => {
    const updateTablePresence = () => {
      // Start zone and rooms are non-table voice areas. If the user is
      // transiently duplicated in both table + non-table areas, prefer
      // non-table state so table-call does not auto-join.
      const isInAreaWithoutVoiceCall = isUserInAreaWithoutVoiceCall({
        sharedTree,
        userId: user.id,
      });
      if (isInAreaWithoutVoiceCall) {
        setCurrentTableId(null);
        return;
      }

      const tableId = getTableIdFromUser({ sharedTree, userId: user.id });

      // Other services depend on the return type of userIsAtTableId, so we'll just handle the empty string case here
      setCurrentTableId(tableId);
    };

    updateTablePresence();

    return Tree.on(sharedTree.root, "treeChanged", updateTablePresence);
  }, [user.id, sharedTree]);

  return {
    // Where is the current user sitting?
    tableId: currentTableId,
  };
};
